// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v4.25.4
// source: src/bfsp.proto
/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";
export const protobufPackage = "bfsp.files";
function createBaseEncryptedFileMetadata() {
    return { metadata: new Uint8Array(0), id: "" };
}
export const EncryptedFileMetadata = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.metadata.length !== 0) {
            writer.uint32(10).bytes(message.metadata);
        }
        if (message.id !== "") {
            writer.uint32(18).string(message.id);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseEncryptedFileMetadata();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.metadata = reader.bytes();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            metadata: isSet(object.metadata) ? bytesFromBase64(object.metadata) : new Uint8Array(0),
            id: isSet(object.id) ? globalThis.String(object.id) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.metadata.length !== 0) {
            obj.metadata = base64FromBytes(message.metadata);
        }
        if (message.id !== "") {
            obj.id = message.id;
        }
        return obj;
    },
    create(base) {
        return EncryptedFileMetadata.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseEncryptedFileMetadata();
        message.metadata = object.metadata ?? new Uint8Array(0);
        message.id = object.id ?? "";
        return message;
    },
};
function createBaseFileServerMessage() {
    return {
        auth: undefined,
        uploadChunk: undefined,
        chunksUploadedQuery: undefined,
        downloadChunkQuery: undefined,
        deleteChunksQuery: undefined,
        uploadFileMetadata: undefined,
        downloadFileMetadataQuery: undefined,
        listFileMetadataQuery: undefined,
        listChunkMetadataQuery: undefined,
        deleteFileMetadataQuery: undefined,
        getUsageQuery: undefined,
        setMasterKey: undefined,
        getMasterKey: undefined,
    };
}
export const FileServerMessage = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.auth !== undefined) {
            FileServerMessage_Authentication.encode(message.auth, writer.uint32(10).fork()).ldelim();
        }
        if (message.uploadChunk !== undefined) {
            FileServerMessage_UploadChunk.encode(message.uploadChunk, writer.uint32(18).fork()).ldelim();
        }
        if (message.chunksUploadedQuery !== undefined) {
            FileServerMessage_ChunksUploadedQuery.encode(message.chunksUploadedQuery, writer.uint32(26).fork()).ldelim();
        }
        if (message.downloadChunkQuery !== undefined) {
            FileServerMessage_DownloadChunkQuery.encode(message.downloadChunkQuery, writer.uint32(34).fork()).ldelim();
        }
        if (message.deleteChunksQuery !== undefined) {
            FileServerMessage_DeleteChunksQuery.encode(message.deleteChunksQuery, writer.uint32(42).fork()).ldelim();
        }
        if (message.uploadFileMetadata !== undefined) {
            FileServerMessage_UploadFileMetadata.encode(message.uploadFileMetadata, writer.uint32(50).fork()).ldelim();
        }
        if (message.downloadFileMetadataQuery !== undefined) {
            FileServerMessage_DownloadFileMetadataQuery.encode(message.downloadFileMetadataQuery, writer.uint32(58).fork())
                .ldelim();
        }
        if (message.listFileMetadataQuery !== undefined) {
            FileServerMessage_ListFileMetadataQuery.encode(message.listFileMetadataQuery, writer.uint32(66).fork()).ldelim();
        }
        if (message.listChunkMetadataQuery !== undefined) {
            FileServerMessage_ListChunkMetadataQuery.encode(message.listChunkMetadataQuery, writer.uint32(74).fork())
                .ldelim();
        }
        if (message.deleteFileMetadataQuery !== undefined) {
            FileServerMessage_DeleteFileMetadataQuery.encode(message.deleteFileMetadataQuery, writer.uint32(82).fork())
                .ldelim();
        }
        if (message.getUsageQuery !== undefined) {
            FileServerMessage_GetUsageQuery.encode(message.getUsageQuery, writer.uint32(90).fork()).ldelim();
        }
        if (message.setMasterKey !== undefined) {
            FileServerMessage_SetMasterEncryptionKey.encode(message.setMasterKey, writer.uint32(98).fork()).ldelim();
        }
        if (message.getMasterKey !== undefined) {
            FileServerMessage_GetMasterEncryptionKey.encode(message.getMasterKey, writer.uint32(106).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFileServerMessage();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.auth = FileServerMessage_Authentication.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.uploadChunk = FileServerMessage_UploadChunk.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.chunksUploadedQuery = FileServerMessage_ChunksUploadedQuery.decode(reader, reader.uint32());
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.downloadChunkQuery = FileServerMessage_DownloadChunkQuery.decode(reader, reader.uint32());
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.deleteChunksQuery = FileServerMessage_DeleteChunksQuery.decode(reader, reader.uint32());
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.uploadFileMetadata = FileServerMessage_UploadFileMetadata.decode(reader, reader.uint32());
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.downloadFileMetadataQuery = FileServerMessage_DownloadFileMetadataQuery.decode(reader, reader.uint32());
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.listFileMetadataQuery = FileServerMessage_ListFileMetadataQuery.decode(reader, reader.uint32());
                    continue;
                case 9:
                    if (tag !== 74) {
                        break;
                    }
                    message.listChunkMetadataQuery = FileServerMessage_ListChunkMetadataQuery.decode(reader, reader.uint32());
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.deleteFileMetadataQuery = FileServerMessage_DeleteFileMetadataQuery.decode(reader, reader.uint32());
                    continue;
                case 11:
                    if (tag !== 90) {
                        break;
                    }
                    message.getUsageQuery = FileServerMessage_GetUsageQuery.decode(reader, reader.uint32());
                    continue;
                case 12:
                    if (tag !== 98) {
                        break;
                    }
                    message.setMasterKey = FileServerMessage_SetMasterEncryptionKey.decode(reader, reader.uint32());
                    continue;
                case 13:
                    if (tag !== 106) {
                        break;
                    }
                    message.getMasterKey = FileServerMessage_GetMasterEncryptionKey.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            auth: isSet(object.auth) ? FileServerMessage_Authentication.fromJSON(object.auth) : undefined,
            uploadChunk: isSet(object.uploadChunk) ? FileServerMessage_UploadChunk.fromJSON(object.uploadChunk) : undefined,
            chunksUploadedQuery: isSet(object.chunksUploadedQuery)
                ? FileServerMessage_ChunksUploadedQuery.fromJSON(object.chunksUploadedQuery)
                : undefined,
            downloadChunkQuery: isSet(object.downloadChunkQuery)
                ? FileServerMessage_DownloadChunkQuery.fromJSON(object.downloadChunkQuery)
                : undefined,
            deleteChunksQuery: isSet(object.deleteChunksQuery)
                ? FileServerMessage_DeleteChunksQuery.fromJSON(object.deleteChunksQuery)
                : undefined,
            uploadFileMetadata: isSet(object.uploadFileMetadata)
                ? FileServerMessage_UploadFileMetadata.fromJSON(object.uploadFileMetadata)
                : undefined,
            downloadFileMetadataQuery: isSet(object.downloadFileMetadataQuery)
                ? FileServerMessage_DownloadFileMetadataQuery.fromJSON(object.downloadFileMetadataQuery)
                : undefined,
            listFileMetadataQuery: isSet(object.listFileMetadataQuery)
                ? FileServerMessage_ListFileMetadataQuery.fromJSON(object.listFileMetadataQuery)
                : undefined,
            listChunkMetadataQuery: isSet(object.listChunkMetadataQuery)
                ? FileServerMessage_ListChunkMetadataQuery.fromJSON(object.listChunkMetadataQuery)
                : undefined,
            deleteFileMetadataQuery: isSet(object.deleteFileMetadataQuery)
                ? FileServerMessage_DeleteFileMetadataQuery.fromJSON(object.deleteFileMetadataQuery)
                : undefined,
            getUsageQuery: isSet(object.getUsageQuery)
                ? FileServerMessage_GetUsageQuery.fromJSON(object.getUsageQuery)
                : undefined,
            setMasterKey: isSet(object.setMasterKey)
                ? FileServerMessage_SetMasterEncryptionKey.fromJSON(object.setMasterKey)
                : undefined,
            getMasterKey: isSet(object.getMasterKey)
                ? FileServerMessage_GetMasterEncryptionKey.fromJSON(object.getMasterKey)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.auth !== undefined) {
            obj.auth = FileServerMessage_Authentication.toJSON(message.auth);
        }
        if (message.uploadChunk !== undefined) {
            obj.uploadChunk = FileServerMessage_UploadChunk.toJSON(message.uploadChunk);
        }
        if (message.chunksUploadedQuery !== undefined) {
            obj.chunksUploadedQuery = FileServerMessage_ChunksUploadedQuery.toJSON(message.chunksUploadedQuery);
        }
        if (message.downloadChunkQuery !== undefined) {
            obj.downloadChunkQuery = FileServerMessage_DownloadChunkQuery.toJSON(message.downloadChunkQuery);
        }
        if (message.deleteChunksQuery !== undefined) {
            obj.deleteChunksQuery = FileServerMessage_DeleteChunksQuery.toJSON(message.deleteChunksQuery);
        }
        if (message.uploadFileMetadata !== undefined) {
            obj.uploadFileMetadata = FileServerMessage_UploadFileMetadata.toJSON(message.uploadFileMetadata);
        }
        if (message.downloadFileMetadataQuery !== undefined) {
            obj.downloadFileMetadataQuery = FileServerMessage_DownloadFileMetadataQuery.toJSON(message.downloadFileMetadataQuery);
        }
        if (message.listFileMetadataQuery !== undefined) {
            obj.listFileMetadataQuery = FileServerMessage_ListFileMetadataQuery.toJSON(message.listFileMetadataQuery);
        }
        if (message.listChunkMetadataQuery !== undefined) {
            obj.listChunkMetadataQuery = FileServerMessage_ListChunkMetadataQuery.toJSON(message.listChunkMetadataQuery);
        }
        if (message.deleteFileMetadataQuery !== undefined) {
            obj.deleteFileMetadataQuery = FileServerMessage_DeleteFileMetadataQuery.toJSON(message.deleteFileMetadataQuery);
        }
        if (message.getUsageQuery !== undefined) {
            obj.getUsageQuery = FileServerMessage_GetUsageQuery.toJSON(message.getUsageQuery);
        }
        if (message.setMasterKey !== undefined) {
            obj.setMasterKey = FileServerMessage_SetMasterEncryptionKey.toJSON(message.setMasterKey);
        }
        if (message.getMasterKey !== undefined) {
            obj.getMasterKey = FileServerMessage_GetMasterEncryptionKey.toJSON(message.getMasterKey);
        }
        return obj;
    },
    create(base) {
        return FileServerMessage.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFileServerMessage();
        message.auth = (object.auth !== undefined && object.auth !== null)
            ? FileServerMessage_Authentication.fromPartial(object.auth)
            : undefined;
        message.uploadChunk = (object.uploadChunk !== undefined && object.uploadChunk !== null)
            ? FileServerMessage_UploadChunk.fromPartial(object.uploadChunk)
            : undefined;
        message.chunksUploadedQuery = (object.chunksUploadedQuery !== undefined && object.chunksUploadedQuery !== null)
            ? FileServerMessage_ChunksUploadedQuery.fromPartial(object.chunksUploadedQuery)
            : undefined;
        message.downloadChunkQuery = (object.downloadChunkQuery !== undefined && object.downloadChunkQuery !== null)
            ? FileServerMessage_DownloadChunkQuery.fromPartial(object.downloadChunkQuery)
            : undefined;
        message.deleteChunksQuery = (object.deleteChunksQuery !== undefined && object.deleteChunksQuery !== null)
            ? FileServerMessage_DeleteChunksQuery.fromPartial(object.deleteChunksQuery)
            : undefined;
        message.uploadFileMetadata = (object.uploadFileMetadata !== undefined && object.uploadFileMetadata !== null)
            ? FileServerMessage_UploadFileMetadata.fromPartial(object.uploadFileMetadata)
            : undefined;
        message.downloadFileMetadataQuery =
            (object.downloadFileMetadataQuery !== undefined && object.downloadFileMetadataQuery !== null)
                ? FileServerMessage_DownloadFileMetadataQuery.fromPartial(object.downloadFileMetadataQuery)
                : undefined;
        message.listFileMetadataQuery =
            (object.listFileMetadataQuery !== undefined && object.listFileMetadataQuery !== null)
                ? FileServerMessage_ListFileMetadataQuery.fromPartial(object.listFileMetadataQuery)
                : undefined;
        message.listChunkMetadataQuery =
            (object.listChunkMetadataQuery !== undefined && object.listChunkMetadataQuery !== null)
                ? FileServerMessage_ListChunkMetadataQuery.fromPartial(object.listChunkMetadataQuery)
                : undefined;
        message.deleteFileMetadataQuery =
            (object.deleteFileMetadataQuery !== undefined && object.deleteFileMetadataQuery !== null)
                ? FileServerMessage_DeleteFileMetadataQuery.fromPartial(object.deleteFileMetadataQuery)
                : undefined;
        message.getUsageQuery = (object.getUsageQuery !== undefined && object.getUsageQuery !== null)
            ? FileServerMessage_GetUsageQuery.fromPartial(object.getUsageQuery)
            : undefined;
        message.setMasterKey = (object.setMasterKey !== undefined && object.setMasterKey !== null)
            ? FileServerMessage_SetMasterEncryptionKey.fromPartial(object.setMasterKey)
            : undefined;
        message.getMasterKey = (object.getMasterKey !== undefined && object.getMasterKey !== null)
            ? FileServerMessage_GetMasterEncryptionKey.fromPartial(object.getMasterKey)
            : undefined;
        return message;
    },
};
function createBaseFileServerMessage_UploadChunk() {
    return { chunkMetadata: undefined, chunk: new Uint8Array(0), encChunkMetadata: undefined };
}
export const FileServerMessage_UploadChunk = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.chunkMetadata !== undefined) {
            ChunkMetadata.encode(message.chunkMetadata, writer.uint32(10).fork()).ldelim();
        }
        if (message.chunk.length !== 0) {
            writer.uint32(18).bytes(message.chunk);
        }
        if (message.encChunkMetadata !== undefined) {
            EncryptedChunkMetadata.encode(message.encChunkMetadata, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFileServerMessage_UploadChunk();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.chunkMetadata = ChunkMetadata.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.chunk = reader.bytes();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.encChunkMetadata = EncryptedChunkMetadata.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            chunkMetadata: isSet(object.chunkMetadata) ? ChunkMetadata.fromJSON(object.chunkMetadata) : undefined,
            chunk: isSet(object.chunk) ? bytesFromBase64(object.chunk) : new Uint8Array(0),
            encChunkMetadata: isSet(object.encChunkMetadata)
                ? EncryptedChunkMetadata.fromJSON(object.encChunkMetadata)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.chunkMetadata !== undefined) {
            obj.chunkMetadata = ChunkMetadata.toJSON(message.chunkMetadata);
        }
        if (message.chunk.length !== 0) {
            obj.chunk = base64FromBytes(message.chunk);
        }
        if (message.encChunkMetadata !== undefined) {
            obj.encChunkMetadata = EncryptedChunkMetadata.toJSON(message.encChunkMetadata);
        }
        return obj;
    },
    create(base) {
        return FileServerMessage_UploadChunk.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFileServerMessage_UploadChunk();
        message.chunkMetadata = (object.chunkMetadata !== undefined && object.chunkMetadata !== null)
            ? ChunkMetadata.fromPartial(object.chunkMetadata)
            : undefined;
        message.chunk = object.chunk ?? new Uint8Array(0);
        message.encChunkMetadata = (object.encChunkMetadata !== undefined && object.encChunkMetadata !== null)
            ? EncryptedChunkMetadata.fromPartial(object.encChunkMetadata)
            : undefined;
        return message;
    },
};
function createBaseFileServerMessage_ChunksUploadedQuery() {
    return { chunkIds: [] };
}
export const FileServerMessage_ChunksUploadedQuery = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.chunkIds) {
            writer.uint32(10).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFileServerMessage_ChunksUploadedQuery();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.chunkIds.push(reader.string());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            chunkIds: globalThis.Array.isArray(object?.chunkIds) ? object.chunkIds.map((e) => globalThis.String(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.chunkIds?.length) {
            obj.chunkIds = message.chunkIds;
        }
        return obj;
    },
    create(base) {
        return FileServerMessage_ChunksUploadedQuery.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFileServerMessage_ChunksUploadedQuery();
        message.chunkIds = object.chunkIds?.map((e) => e) || [];
        return message;
    },
};
function createBaseFileServerMessage_ListChunkMetadataQuery() {
    return { ids: [] };
}
export const FileServerMessage_ListChunkMetadataQuery = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.ids) {
            writer.uint32(10).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFileServerMessage_ListChunkMetadataQuery();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.ids.push(reader.string());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { ids: globalThis.Array.isArray(object?.ids) ? object.ids.map((e) => globalThis.String(e)) : [] };
    },
    toJSON(message) {
        const obj = {};
        if (message.ids?.length) {
            obj.ids = message.ids;
        }
        return obj;
    },
    create(base) {
        return FileServerMessage_ListChunkMetadataQuery.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFileServerMessage_ListChunkMetadataQuery();
        message.ids = object.ids?.map((e) => e) || [];
        return message;
    },
};
function createBaseFileServerMessage_DownloadChunkQuery() {
    return { chunkId: "" };
}
export const FileServerMessage_DownloadChunkQuery = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.chunkId !== "") {
            writer.uint32(10).string(message.chunkId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFileServerMessage_DownloadChunkQuery();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.chunkId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { chunkId: isSet(object.chunkId) ? globalThis.String(object.chunkId) : "" };
    },
    toJSON(message) {
        const obj = {};
        if (message.chunkId !== "") {
            obj.chunkId = message.chunkId;
        }
        return obj;
    },
    create(base) {
        return FileServerMessage_DownloadChunkQuery.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFileServerMessage_DownloadChunkQuery();
        message.chunkId = object.chunkId ?? "";
        return message;
    },
};
function createBaseFileServerMessage_DeleteChunksQuery() {
    return { chunkIds: [] };
}
export const FileServerMessage_DeleteChunksQuery = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.chunkIds) {
            writer.uint32(10).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFileServerMessage_DeleteChunksQuery();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.chunkIds.push(reader.string());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            chunkIds: globalThis.Array.isArray(object?.chunkIds) ? object.chunkIds.map((e) => globalThis.String(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.chunkIds?.length) {
            obj.chunkIds = message.chunkIds;
        }
        return obj;
    },
    create(base) {
        return FileServerMessage_DeleteChunksQuery.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFileServerMessage_DeleteChunksQuery();
        message.chunkIds = object.chunkIds?.map((e) => e) || [];
        return message;
    },
};
function createBaseFileServerMessage_Authentication() {
    return { token: "" };
}
export const FileServerMessage_Authentication = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.token !== "") {
            writer.uint32(10).string(message.token);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFileServerMessage_Authentication();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.token = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { token: isSet(object.token) ? globalThis.String(object.token) : "" };
    },
    toJSON(message) {
        const obj = {};
        if (message.token !== "") {
            obj.token = message.token;
        }
        return obj;
    },
    create(base) {
        return FileServerMessage_Authentication.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFileServerMessage_Authentication();
        message.token = object.token ?? "";
        return message;
    },
};
function createBaseFileServerMessage_UploadFileMetadata() {
    return { encryptedFileMetadata: undefined };
}
export const FileServerMessage_UploadFileMetadata = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.encryptedFileMetadata !== undefined) {
            EncryptedFileMetadata.encode(message.encryptedFileMetadata, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFileServerMessage_UploadFileMetadata();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.encryptedFileMetadata = EncryptedFileMetadata.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            encryptedFileMetadata: isSet(object.encryptedFileMetadata)
                ? EncryptedFileMetadata.fromJSON(object.encryptedFileMetadata)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.encryptedFileMetadata !== undefined) {
            obj.encryptedFileMetadata = EncryptedFileMetadata.toJSON(message.encryptedFileMetadata);
        }
        return obj;
    },
    create(base) {
        return FileServerMessage_UploadFileMetadata.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFileServerMessage_UploadFileMetadata();
        message.encryptedFileMetadata =
            (object.encryptedFileMetadata !== undefined && object.encryptedFileMetadata !== null)
                ? EncryptedFileMetadata.fromPartial(object.encryptedFileMetadata)
                : undefined;
        return message;
    },
};
function createBaseFileServerMessage_DownloadFileMetadataQuery() {
    return { id: "" };
}
export const FileServerMessage_DownloadFileMetadataQuery = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFileServerMessage_DownloadFileMetadataQuery();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { id: isSet(object.id) ? globalThis.String(object.id) : "" };
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== "") {
            obj.id = message.id;
        }
        return obj;
    },
    create(base) {
        return FileServerMessage_DownloadFileMetadataQuery.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFileServerMessage_DownloadFileMetadataQuery();
        message.id = object.id ?? "";
        return message;
    },
};
function createBaseFileServerMessage_ListFileMetadataQuery() {
    return { ids: [] };
}
export const FileServerMessage_ListFileMetadataQuery = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.ids) {
            writer.uint32(10).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFileServerMessage_ListFileMetadataQuery();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.ids.push(reader.string());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { ids: globalThis.Array.isArray(object?.ids) ? object.ids.map((e) => globalThis.String(e)) : [] };
    },
    toJSON(message) {
        const obj = {};
        if (message.ids?.length) {
            obj.ids = message.ids;
        }
        return obj;
    },
    create(base) {
        return FileServerMessage_ListFileMetadataQuery.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFileServerMessage_ListFileMetadataQuery();
        message.ids = object.ids?.map((e) => e) || [];
        return message;
    },
};
function createBaseFileServerMessage_DeleteFileMetadataQuery() {
    return { id: "" };
}
export const FileServerMessage_DeleteFileMetadataQuery = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFileServerMessage_DeleteFileMetadataQuery();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { id: isSet(object.id) ? globalThis.String(object.id) : "" };
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== "") {
            obj.id = message.id;
        }
        return obj;
    },
    create(base) {
        return FileServerMessage_DeleteFileMetadataQuery.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFileServerMessage_DeleteFileMetadataQuery();
        message.id = object.id ?? "";
        return message;
    },
};
function createBaseFileServerMessage_GetUsageQuery() {
    return {};
}
export const FileServerMessage_GetUsageQuery = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFileServerMessage_GetUsageQuery();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return FileServerMessage_GetUsageQuery.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseFileServerMessage_GetUsageQuery();
        return message;
    },
};
function createBaseFileServerMessage_SetMasterEncryptionKey() {
    return { encryptedKey: new Uint8Array(0) };
}
export const FileServerMessage_SetMasterEncryptionKey = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.encryptedKey.length !== 0) {
            writer.uint32(10).bytes(message.encryptedKey);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFileServerMessage_SetMasterEncryptionKey();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.encryptedKey = reader.bytes();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { encryptedKey: isSet(object.encryptedKey) ? bytesFromBase64(object.encryptedKey) : new Uint8Array(0) };
    },
    toJSON(message) {
        const obj = {};
        if (message.encryptedKey.length !== 0) {
            obj.encryptedKey = base64FromBytes(message.encryptedKey);
        }
        return obj;
    },
    create(base) {
        return FileServerMessage_SetMasterEncryptionKey.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFileServerMessage_SetMasterEncryptionKey();
        message.encryptedKey = object.encryptedKey ?? new Uint8Array(0);
        return message;
    },
};
function createBaseFileServerMessage_GetMasterEncryptionKey() {
    return {};
}
export const FileServerMessage_GetMasterEncryptionKey = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFileServerMessage_GetMasterEncryptionKey();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return FileServerMessage_GetMasterEncryptionKey.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseFileServerMessage_GetMasterEncryptionKey();
        return message;
    },
};
function createBaseUploadChunkResp() {
    return { err: undefined };
}
export const UploadChunkResp = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.err !== undefined) {
            writer.uint32(10).string(message.err);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUploadChunkResp();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.err = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { err: isSet(object.err) ? globalThis.String(object.err) : undefined };
    },
    toJSON(message) {
        const obj = {};
        if (message.err !== undefined) {
            obj.err = message.err;
        }
        return obj;
    },
    create(base) {
        return UploadChunkResp.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUploadChunkResp();
        message.err = object.err ?? undefined;
        return message;
    },
};
function createBaseDownloadChunkResp() {
    return { chunkData: undefined, err: undefined };
}
export const DownloadChunkResp = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.chunkData !== undefined) {
            DownloadChunkResp_ChunkData.encode(message.chunkData, writer.uint32(10).fork()).ldelim();
        }
        if (message.err !== undefined) {
            writer.uint32(18).string(message.err);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDownloadChunkResp();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.chunkData = DownloadChunkResp_ChunkData.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.err = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            chunkData: isSet(object.chunkData) ? DownloadChunkResp_ChunkData.fromJSON(object.chunkData) : undefined,
            err: isSet(object.err) ? globalThis.String(object.err) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.chunkData !== undefined) {
            obj.chunkData = DownloadChunkResp_ChunkData.toJSON(message.chunkData);
        }
        if (message.err !== undefined) {
            obj.err = message.err;
        }
        return obj;
    },
    create(base) {
        return DownloadChunkResp.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDownloadChunkResp();
        message.chunkData = (object.chunkData !== undefined && object.chunkData !== null)
            ? DownloadChunkResp_ChunkData.fromPartial(object.chunkData)
            : undefined;
        message.err = object.err ?? undefined;
        return message;
    },
};
function createBaseDownloadChunkResp_ChunkData() {
    return { chunkMetadata: undefined, chunk: new Uint8Array(0), encChunkMetadata: undefined };
}
export const DownloadChunkResp_ChunkData = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.chunkMetadata !== undefined) {
            ChunkMetadata.encode(message.chunkMetadata, writer.uint32(10).fork()).ldelim();
        }
        if (message.chunk.length !== 0) {
            writer.uint32(18).bytes(message.chunk);
        }
        if (message.encChunkMetadata !== undefined) {
            EncryptedChunkMetadata.encode(message.encChunkMetadata, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDownloadChunkResp_ChunkData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.chunkMetadata = ChunkMetadata.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.chunk = reader.bytes();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.encChunkMetadata = EncryptedChunkMetadata.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            chunkMetadata: isSet(object.chunkMetadata) ? ChunkMetadata.fromJSON(object.chunkMetadata) : undefined,
            chunk: isSet(object.chunk) ? bytesFromBase64(object.chunk) : new Uint8Array(0),
            encChunkMetadata: isSet(object.encChunkMetadata)
                ? EncryptedChunkMetadata.fromJSON(object.encChunkMetadata)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.chunkMetadata !== undefined) {
            obj.chunkMetadata = ChunkMetadata.toJSON(message.chunkMetadata);
        }
        if (message.chunk.length !== 0) {
            obj.chunk = base64FromBytes(message.chunk);
        }
        if (message.encChunkMetadata !== undefined) {
            obj.encChunkMetadata = EncryptedChunkMetadata.toJSON(message.encChunkMetadata);
        }
        return obj;
    },
    create(base) {
        return DownloadChunkResp_ChunkData.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDownloadChunkResp_ChunkData();
        message.chunkMetadata = (object.chunkMetadata !== undefined && object.chunkMetadata !== null)
            ? ChunkMetadata.fromPartial(object.chunkMetadata)
            : undefined;
        message.chunk = object.chunk ?? new Uint8Array(0);
        message.encChunkMetadata = (object.encChunkMetadata !== undefined && object.encChunkMetadata !== null)
            ? EncryptedChunkMetadata.fromPartial(object.encChunkMetadata)
            : undefined;
        return message;
    },
};
function createBaseChunksUploadedQueryResp() {
    return { chunks: undefined, err: undefined };
}
export const ChunksUploadedQueryResp = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.chunks !== undefined) {
            ChunksUploadedQueryResp_ChunksUploaded.encode(message.chunks, writer.uint32(10).fork()).ldelim();
        }
        if (message.err !== undefined) {
            writer.uint32(18).string(message.err);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseChunksUploadedQueryResp();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.chunks = ChunksUploadedQueryResp_ChunksUploaded.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.err = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            chunks: isSet(object.chunks) ? ChunksUploadedQueryResp_ChunksUploaded.fromJSON(object.chunks) : undefined,
            err: isSet(object.err) ? globalThis.String(object.err) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.chunks !== undefined) {
            obj.chunks = ChunksUploadedQueryResp_ChunksUploaded.toJSON(message.chunks);
        }
        if (message.err !== undefined) {
            obj.err = message.err;
        }
        return obj;
    },
    create(base) {
        return ChunksUploadedQueryResp.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseChunksUploadedQueryResp();
        message.chunks = (object.chunks !== undefined && object.chunks !== null)
            ? ChunksUploadedQueryResp_ChunksUploaded.fromPartial(object.chunks)
            : undefined;
        message.err = object.err ?? undefined;
        return message;
    },
};
function createBaseChunksUploadedQueryResp_ChunkUploaded() {
    return { chunkId: new Uint8Array(0), uploaded: false };
}
export const ChunksUploadedQueryResp_ChunkUploaded = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.chunkId.length !== 0) {
            writer.uint32(10).bytes(message.chunkId);
        }
        if (message.uploaded !== false) {
            writer.uint32(16).bool(message.uploaded);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseChunksUploadedQueryResp_ChunkUploaded();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.chunkId = reader.bytes();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.uploaded = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            chunkId: isSet(object.chunkId) ? bytesFromBase64(object.chunkId) : new Uint8Array(0),
            uploaded: isSet(object.uploaded) ? globalThis.Boolean(object.uploaded) : false,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.chunkId.length !== 0) {
            obj.chunkId = base64FromBytes(message.chunkId);
        }
        if (message.uploaded !== false) {
            obj.uploaded = message.uploaded;
        }
        return obj;
    },
    create(base) {
        return ChunksUploadedQueryResp_ChunkUploaded.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseChunksUploadedQueryResp_ChunkUploaded();
        message.chunkId = object.chunkId ?? new Uint8Array(0);
        message.uploaded = object.uploaded ?? false;
        return message;
    },
};
function createBaseChunksUploadedQueryResp_ChunksUploaded() {
    return { chunks: [] };
}
export const ChunksUploadedQueryResp_ChunksUploaded = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.chunks) {
            ChunksUploadedQueryResp_ChunkUploaded.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseChunksUploadedQueryResp_ChunksUploaded();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.chunks.push(ChunksUploadedQueryResp_ChunkUploaded.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            chunks: globalThis.Array.isArray(object?.chunks)
                ? object.chunks.map((e) => ChunksUploadedQueryResp_ChunkUploaded.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.chunks?.length) {
            obj.chunks = message.chunks.map((e) => ChunksUploadedQueryResp_ChunkUploaded.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return ChunksUploadedQueryResp_ChunksUploaded.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseChunksUploadedQueryResp_ChunksUploaded();
        message.chunks = object.chunks?.map((e) => ChunksUploadedQueryResp_ChunkUploaded.fromPartial(e)) || [];
        return message;
    },
};
function createBaseDeleteChunksResp() {
    return { err: undefined };
}
export const DeleteChunksResp = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.err !== undefined) {
            writer.uint32(10).string(message.err);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDeleteChunksResp();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.err = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { err: isSet(object.err) ? globalThis.String(object.err) : undefined };
    },
    toJSON(message) {
        const obj = {};
        if (message.err !== undefined) {
            obj.err = message.err;
        }
        return obj;
    },
    create(base) {
        return DeleteChunksResp.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDeleteChunksResp();
        message.err = object.err ?? undefined;
        return message;
    },
};
function createBaseDeleteFileMetadataResp() {
    return { err: undefined };
}
export const DeleteFileMetadataResp = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.err !== undefined) {
            writer.uint32(10).string(message.err);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDeleteFileMetadataResp();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.err = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { err: isSet(object.err) ? globalThis.String(object.err) : undefined };
    },
    toJSON(message) {
        const obj = {};
        if (message.err !== undefined) {
            obj.err = message.err;
        }
        return obj;
    },
    create(base) {
        return DeleteFileMetadataResp.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDeleteFileMetadataResp();
        message.err = object.err ?? undefined;
        return message;
    },
};
function createBaseUploadFileMetadataResp() {
    return { err: undefined };
}
export const UploadFileMetadataResp = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.err !== undefined) {
            writer.uint32(10).string(message.err);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUploadFileMetadataResp();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.err = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { err: isSet(object.err) ? globalThis.String(object.err) : undefined };
    },
    toJSON(message) {
        const obj = {};
        if (message.err !== undefined) {
            obj.err = message.err;
        }
        return obj;
    },
    create(base) {
        return UploadFileMetadataResp.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUploadFileMetadataResp();
        message.err = object.err ?? undefined;
        return message;
    },
};
function createBaseDownloadFileMetadataResp() {
    return { encryptedFileMetadata: undefined, err: undefined };
}
export const DownloadFileMetadataResp = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.encryptedFileMetadata !== undefined) {
            EncryptedFileMetadata.encode(message.encryptedFileMetadata, writer.uint32(10).fork()).ldelim();
        }
        if (message.err !== undefined) {
            writer.uint32(18).string(message.err);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDownloadFileMetadataResp();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.encryptedFileMetadata = EncryptedFileMetadata.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.err = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            encryptedFileMetadata: isSet(object.encryptedFileMetadata)
                ? EncryptedFileMetadata.fromJSON(object.encryptedFileMetadata)
                : undefined,
            err: isSet(object.err) ? globalThis.String(object.err) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.encryptedFileMetadata !== undefined) {
            obj.encryptedFileMetadata = EncryptedFileMetadata.toJSON(message.encryptedFileMetadata);
        }
        if (message.err !== undefined) {
            obj.err = message.err;
        }
        return obj;
    },
    create(base) {
        return DownloadFileMetadataResp.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDownloadFileMetadataResp();
        message.encryptedFileMetadata =
            (object.encryptedFileMetadata !== undefined && object.encryptedFileMetadata !== null)
                ? EncryptedFileMetadata.fromPartial(object.encryptedFileMetadata)
                : undefined;
        message.err = object.err ?? undefined;
        return message;
    },
};
function createBaseListFileMetadataResp() {
    return { metadatas: undefined, err: undefined };
}
export const ListFileMetadataResp = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.metadatas !== undefined) {
            ListFileMetadataResp_FileMetadatas.encode(message.metadatas, writer.uint32(10).fork()).ldelim();
        }
        if (message.err !== undefined) {
            writer.uint32(18).string(message.err);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseListFileMetadataResp();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.metadatas = ListFileMetadataResp_FileMetadatas.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.err = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            metadatas: isSet(object.metadatas) ? ListFileMetadataResp_FileMetadatas.fromJSON(object.metadatas) : undefined,
            err: isSet(object.err) ? globalThis.String(object.err) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.metadatas !== undefined) {
            obj.metadatas = ListFileMetadataResp_FileMetadatas.toJSON(message.metadatas);
        }
        if (message.err !== undefined) {
            obj.err = message.err;
        }
        return obj;
    },
    create(base) {
        return ListFileMetadataResp.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseListFileMetadataResp();
        message.metadatas = (object.metadatas !== undefined && object.metadatas !== null)
            ? ListFileMetadataResp_FileMetadatas.fromPartial(object.metadatas)
            : undefined;
        message.err = object.err ?? undefined;
        return message;
    },
};
function createBaseListFileMetadataResp_FileMetadatas() {
    return { metadatas: {} };
}
export const ListFileMetadataResp_FileMetadatas = {
    encode(message, writer = _m0.Writer.create()) {
        Object.entries(message.metadatas).forEach(([key, value]) => {
            ListFileMetadataResp_FileMetadatas_MetadatasEntry.encode({ key: key, value }, writer.uint32(10).fork())
                .ldelim();
        });
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseListFileMetadataResp_FileMetadatas();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    const entry1 = ListFileMetadataResp_FileMetadatas_MetadatasEntry.decode(reader, reader.uint32());
                    if (entry1.value !== undefined) {
                        message.metadatas[entry1.key] = entry1.value;
                    }
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            metadatas: isObject(object.metadatas)
                ? Object.entries(object.metadatas).reduce((acc, [key, value]) => {
                    acc[key] = EncryptedFileMetadata.fromJSON(value);
                    return acc;
                }, {})
                : {},
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.metadatas) {
            const entries = Object.entries(message.metadatas);
            if (entries.length > 0) {
                obj.metadatas = {};
                entries.forEach(([k, v]) => {
                    obj.metadatas[k] = EncryptedFileMetadata.toJSON(v);
                });
            }
        }
        return obj;
    },
    create(base) {
        return ListFileMetadataResp_FileMetadatas.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseListFileMetadataResp_FileMetadatas();
        message.metadatas = Object.entries(object.metadatas ?? {}).reduce((acc, [key, value]) => {
            if (value !== undefined) {
                acc[key] = EncryptedFileMetadata.fromPartial(value);
            }
            return acc;
        }, {});
        return message;
    },
};
function createBaseListFileMetadataResp_FileMetadatas_MetadatasEntry() {
    return { key: "", value: undefined };
}
export const ListFileMetadataResp_FileMetadatas_MetadatasEntry = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== undefined) {
            EncryptedFileMetadata.encode(message.value, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseListFileMetadataResp_FileMetadatas_MetadatasEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.value = EncryptedFileMetadata.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            key: isSet(object.key) ? globalThis.String(object.key) : "",
            value: isSet(object.value) ? EncryptedFileMetadata.fromJSON(object.value) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.key !== "") {
            obj.key = message.key;
        }
        if (message.value !== undefined) {
            obj.value = EncryptedFileMetadata.toJSON(message.value);
        }
        return obj;
    },
    create(base) {
        return ListFileMetadataResp_FileMetadatas_MetadatasEntry.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseListFileMetadataResp_FileMetadatas_MetadatasEntry();
        message.key = object.key ?? "";
        message.value = (object.value !== undefined && object.value !== null)
            ? EncryptedFileMetadata.fromPartial(object.value)
            : undefined;
        return message;
    },
};
function createBaseListChunkMetadataResp() {
    return { metadatas: undefined, err: undefined };
}
export const ListChunkMetadataResp = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.metadatas !== undefined) {
            ListChunkMetadataResp_ChunkMetadatas.encode(message.metadatas, writer.uint32(10).fork()).ldelim();
        }
        if (message.err !== undefined) {
            writer.uint32(18).string(message.err);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseListChunkMetadataResp();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.metadatas = ListChunkMetadataResp_ChunkMetadatas.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.err = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            metadatas: isSet(object.metadatas) ? ListChunkMetadataResp_ChunkMetadatas.fromJSON(object.metadatas) : undefined,
            err: isSet(object.err) ? globalThis.String(object.err) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.metadatas !== undefined) {
            obj.metadatas = ListChunkMetadataResp_ChunkMetadatas.toJSON(message.metadatas);
        }
        if (message.err !== undefined) {
            obj.err = message.err;
        }
        return obj;
    },
    create(base) {
        return ListChunkMetadataResp.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseListChunkMetadataResp();
        message.metadatas = (object.metadatas !== undefined && object.metadatas !== null)
            ? ListChunkMetadataResp_ChunkMetadatas.fromPartial(object.metadatas)
            : undefined;
        message.err = object.err ?? undefined;
        return message;
    },
};
function createBaseListChunkMetadataResp_ChunkMetadatas() {
    return { metadatas: {} };
}
export const ListChunkMetadataResp_ChunkMetadatas = {
    encode(message, writer = _m0.Writer.create()) {
        Object.entries(message.metadatas).forEach(([key, value]) => {
            ListChunkMetadataResp_ChunkMetadatas_MetadatasEntry.encode({ key: key, value }, writer.uint32(10).fork())
                .ldelim();
        });
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseListChunkMetadataResp_ChunkMetadatas();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    const entry1 = ListChunkMetadataResp_ChunkMetadatas_MetadatasEntry.decode(reader, reader.uint32());
                    if (entry1.value !== undefined) {
                        message.metadatas[entry1.key] = entry1.value;
                    }
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            metadatas: isObject(object.metadatas)
                ? Object.entries(object.metadatas).reduce((acc, [key, value]) => {
                    acc[key] = ChunkMetadata.fromJSON(value);
                    return acc;
                }, {})
                : {},
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.metadatas) {
            const entries = Object.entries(message.metadatas);
            if (entries.length > 0) {
                obj.metadatas = {};
                entries.forEach(([k, v]) => {
                    obj.metadatas[k] = ChunkMetadata.toJSON(v);
                });
            }
        }
        return obj;
    },
    create(base) {
        return ListChunkMetadataResp_ChunkMetadatas.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseListChunkMetadataResp_ChunkMetadatas();
        message.metadatas = Object.entries(object.metadatas ?? {}).reduce((acc, [key, value]) => {
            if (value !== undefined) {
                acc[key] = ChunkMetadata.fromPartial(value);
            }
            return acc;
        }, {});
        return message;
    },
};
function createBaseListChunkMetadataResp_ChunkMetadatas_MetadatasEntry() {
    return { key: "", value: undefined };
}
export const ListChunkMetadataResp_ChunkMetadatas_MetadatasEntry = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== undefined) {
            ChunkMetadata.encode(message.value, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseListChunkMetadataResp_ChunkMetadatas_MetadatasEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.value = ChunkMetadata.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            key: isSet(object.key) ? globalThis.String(object.key) : "",
            value: isSet(object.value) ? ChunkMetadata.fromJSON(object.value) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.key !== "") {
            obj.key = message.key;
        }
        if (message.value !== undefined) {
            obj.value = ChunkMetadata.toJSON(message.value);
        }
        return obj;
    },
    create(base) {
        return ListChunkMetadataResp_ChunkMetadatas_MetadatasEntry.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseListChunkMetadataResp_ChunkMetadatas_MetadatasEntry();
        message.key = object.key ?? "";
        message.value = (object.value !== undefined && object.value !== null)
            ? ChunkMetadata.fromPartial(object.value)
            : undefined;
        return message;
    },
};
function createBaseGetUsageResp() {
    return { usage: undefined, err: undefined };
}
export const GetUsageResp = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.usage !== undefined) {
            GetUsageResp_Usage.encode(message.usage, writer.uint32(10).fork()).ldelim();
        }
        if (message.err !== undefined) {
            writer.uint32(18).string(message.err);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetUsageResp();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.usage = GetUsageResp_Usage.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.err = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            usage: isSet(object.usage) ? GetUsageResp_Usage.fromJSON(object.usage) : undefined,
            err: isSet(object.err) ? globalThis.String(object.err) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.usage !== undefined) {
            obj.usage = GetUsageResp_Usage.toJSON(message.usage);
        }
        if (message.err !== undefined) {
            obj.err = message.err;
        }
        return obj;
    },
    create(base) {
        return GetUsageResp.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetUsageResp();
        message.usage = (object.usage !== undefined && object.usage !== null)
            ? GetUsageResp_Usage.fromPartial(object.usage)
            : undefined;
        message.err = object.err ?? undefined;
        return message;
    },
};
function createBaseGetUsageResp_Usage() {
    return { totalUsage: 0 };
}
export const GetUsageResp_Usage = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.totalUsage !== 0) {
            writer.uint32(8).uint64(message.totalUsage);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetUsageResp_Usage();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.totalUsage = longToNumber(reader.uint64());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { totalUsage: isSet(object.totalUsage) ? globalThis.Number(object.totalUsage) : 0 };
    },
    toJSON(message) {
        const obj = {};
        if (message.totalUsage !== 0) {
            obj.totalUsage = Math.round(message.totalUsage);
        }
        return obj;
    },
    create(base) {
        return GetUsageResp_Usage.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetUsageResp_Usage();
        message.totalUsage = object.totalUsage ?? 0;
        return message;
    },
};
function createBaseSetMasterEncryptionKeyResp() {
    return { err: undefined };
}
export const SetMasterEncryptionKeyResp = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.err !== undefined) {
            writer.uint32(10).string(message.err);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSetMasterEncryptionKeyResp();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.err = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { err: isSet(object.err) ? globalThis.String(object.err) : undefined };
    },
    toJSON(message) {
        const obj = {};
        if (message.err !== undefined) {
            obj.err = message.err;
        }
        return obj;
    },
    create(base) {
        return SetMasterEncryptionKeyResp.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSetMasterEncryptionKeyResp();
        message.err = object.err ?? undefined;
        return message;
    },
};
function createBaseGetMasterEncryptionKeyResp() {
    return { encryptedKey: undefined, err: undefined };
}
export const GetMasterEncryptionKeyResp = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.encryptedKey !== undefined) {
            writer.uint32(10).bytes(message.encryptedKey);
        }
        if (message.err !== undefined) {
            writer.uint32(18).string(message.err);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetMasterEncryptionKeyResp();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.encryptedKey = reader.bytes();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.err = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            encryptedKey: isSet(object.encryptedKey) ? bytesFromBase64(object.encryptedKey) : undefined,
            err: isSet(object.err) ? globalThis.String(object.err) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.encryptedKey !== undefined) {
            obj.encryptedKey = base64FromBytes(message.encryptedKey);
        }
        if (message.err !== undefined) {
            obj.err = message.err;
        }
        return obj;
    },
    create(base) {
        return GetMasterEncryptionKeyResp.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetMasterEncryptionKeyResp();
        message.encryptedKey = object.encryptedKey ?? undefined;
        message.err = object.err ?? undefined;
        return message;
    },
};
function createBaseEncryptedChunkMetadata() {
    return { id: "", encMetadata: new Uint8Array(0) };
}
export const EncryptedChunkMetadata = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        if (message.encMetadata.length !== 0) {
            writer.uint32(18).bytes(message.encMetadata);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseEncryptedChunkMetadata();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.encMetadata = reader.bytes();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? globalThis.String(object.id) : "",
            encMetadata: isSet(object.encMetadata) ? bytesFromBase64(object.encMetadata) : new Uint8Array(0),
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== "") {
            obj.id = message.id;
        }
        if (message.encMetadata.length !== 0) {
            obj.encMetadata = base64FromBytes(message.encMetadata);
        }
        return obj;
    },
    create(base) {
        return EncryptedChunkMetadata.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseEncryptedChunkMetadata();
        message.id = object.id ?? "";
        message.encMetadata = object.encMetadata ?? new Uint8Array(0);
        return message;
    },
};
function createBaseChunkMetadata() {
    return { id: "", hash: new Uint8Array(0), size: 0, indice: 0, nonce: new Uint8Array(0) };
}
export const ChunkMetadata = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        if (message.hash.length !== 0) {
            writer.uint32(18).bytes(message.hash);
        }
        if (message.size !== 0) {
            writer.uint32(24).uint32(message.size);
        }
        if (message.indice !== 0) {
            writer.uint32(32).int64(message.indice);
        }
        if (message.nonce.length !== 0) {
            writer.uint32(42).bytes(message.nonce);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseChunkMetadata();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.hash = reader.bytes();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.size = reader.uint32();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.indice = longToNumber(reader.int64());
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.nonce = reader.bytes();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? globalThis.String(object.id) : "",
            hash: isSet(object.hash) ? bytesFromBase64(object.hash) : new Uint8Array(0),
            size: isSet(object.size) ? globalThis.Number(object.size) : 0,
            indice: isSet(object.indice) ? globalThis.Number(object.indice) : 0,
            nonce: isSet(object.nonce) ? bytesFromBase64(object.nonce) : new Uint8Array(0),
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== "") {
            obj.id = message.id;
        }
        if (message.hash.length !== 0) {
            obj.hash = base64FromBytes(message.hash);
        }
        if (message.size !== 0) {
            obj.size = Math.round(message.size);
        }
        if (message.indice !== 0) {
            obj.indice = Math.round(message.indice);
        }
        if (message.nonce.length !== 0) {
            obj.nonce = base64FromBytes(message.nonce);
        }
        return obj;
    },
    create(base) {
        return ChunkMetadata.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseChunkMetadata();
        message.id = object.id ?? "";
        message.hash = object.hash ?? new Uint8Array(0);
        message.size = object.size ?? 0;
        message.indice = object.indice ?? 0;
        message.nonce = object.nonce ?? new Uint8Array(0);
        return message;
    },
};
function bytesFromBase64(b64) {
    const bin = globalThis.atob(b64);
    const arr = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; ++i) {
        arr[i] = bin.charCodeAt(i);
    }
    return arr;
}
function base64FromBytes(arr) {
    const bin = [];
    arr.forEach((byte) => {
        bin.push(globalThis.String.fromCharCode(byte));
    });
    return globalThis.btoa(bin.join(""));
}
function longToNumber(long) {
    if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
        throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
    }
    if (long.lt(globalThis.Number.MIN_SAFE_INTEGER)) {
        throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
    }
    return long.toNumber();
}
if (_m0.util.Long !== Long) {
    _m0.util.Long = Long;
    _m0.configure();
}
function isObject(value) {
    return typeof value === "object" && value !== null;
}
function isSet(value) {
    return value !== null && value !== undefined;
}
